module.exports = __webpack_public_path__ + "static/media/UniNeueBold-Italic.b62997ea.eot";